import { render, staticRenderFns } from "./language_proficiency_yukon.vue?vue&type=template&id=0e4f4e13&"
import script from "./language_proficiency_yukon.vue?vue&type=script&lang=js&"
export * from "./language_proficiency_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports